// src/portal/vendor/components/header/VendorHeader.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  RiMenu4Line,
  RiMoonLine,
  RiSunLine,
  RiNotificationLine,
  RiUserLine,
  RiSettings4Line,
  RiLogoutBoxLine,
  RiGlobalLine,
  RiArrowDownSLine,
  RiTimeLine } from
'react-icons/ri';
import { useTheme } from '../../../../contexts/ThemeContext';
import { useAuth } from '../../../../contexts/AuthContext';

const VendorHeader = ({ sidebarOpen, setSidebarOpen }) => {
  const { t, i18n } = useTranslation();
  const { isDarkMode, toggleDarkMode, isRTL } = useTheme();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [clock, setClock] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const timeStr = clock.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  const dateStr = clock.toLocaleDateString([], { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <header className={`h-16 ${isDarkMode ? 'bg-zinc-950 border-zinc-800' : 'bg-white border-gray-200'} border-b flex items-center justify-between px-6 sticky top-0 z-40 w-full`}>
      <div className="flex items-center gap-4">
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className={`p-2 rounded-lg ${isDarkMode ? 'hover:bg-zinc-900 text-zinc-400' : 'hover:bg-gray-100 text-gray-500'}`}>
          <RiMenu4Line size={20} />
        </button>

        <div className={`hidden sm:flex items-center gap-2.5 px-3 py-1.5 rounded-xl border ${isDarkMode ? 'bg-zinc-900 border-zinc-800 text-zinc-400' : 'bg-gray-50 border-gray-200 text-gray-600'}`}>
          <RiTimeLine size={16} className="text-red-500" />
          <div className="flex items-baseline gap-2">
            <span className="text-xs font-bold uppercase tracking-tight text-red-500">{t("live")}</span>
            <span className="text-sm font-mono font-bold tabular-nums">{timeStr}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <button onClick={toggleDarkMode} className={`p-2 rounded-lg ${isDarkMode ? 'hover:bg-zinc-900 text-zinc-400' : 'hover:bg-gray-100 text-gray-500'}`}>
          {isDarkMode ? <RiSunLine size={20} /> : <RiMoonLine size={20} />}
        </button>

        <div className="relative">
          <button
            onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
            className={`flex items-center gap-3 p-1 rounded-lg ${isDarkMode ? 'hover:bg-zinc-900 text-white' : 'hover:bg-gray-100 text-gray-900'} transition-all`}>
            
            <div className="h-8 w-8 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center text-white text-sm font-bold shadow-md">
              {user?.name?.charAt(0) || 'V'}
            </div>
            <div className="hidden md:block text-left leading-none">
              <p className="text-sm font-bold">{user?.name}</p>
              <p className="text-[10px] font-medium text-zinc-500 uppercase tracking-widest mt-1">{user?.role || 'Vendor'}</p>
            </div>
            <RiArrowDownSLine className="text-zinc-500" size={16} />
          </button>

          {profileDropdownOpen &&
          <div className={`absolute right-0 mt-2 w-48 rounded-2xl shadow-2xl ${isDarkMode ? 'bg-zinc-900 border-zinc-800' : 'bg-white border-gray-200'} border p-1 z-50`}>
              <button onClick={() => {navigate('/portal/vendor/profile');setProfileDropdownOpen(false);}} className={`flex items-center gap-3 w-full px-4 py-2.5 text-sm rounded-xl transition-all ${isDarkMode ? 'text-zinc-400 hover:bg-zinc-800 hover:text-white' : 'text-zinc-600 hover:bg-gray-50'}`}>
                <RiUserLine size={18} /> {t("profile")}
              </button>
              <button onClick={() => {navigate('/portal/vendor/profile');setProfileDropdownOpen(false);}} className={`flex items-center gap-3 w-full px-4 py-2.5 text-sm rounded-xl transition-all ${isDarkMode ? 'text-zinc-400 hover:bg-zinc-800 hover:text-white' : 'text-zinc-600 hover:bg-gray-50'}`}>
                <RiSettings4Line size={18} /> {t("settings")}
              </button>
              <div className={`my-1 border-t ${isDarkMode ? 'border-zinc-800' : 'border-gray-100'}`} />
              <button onClick={() => {logout();navigate('/login');}} className={`flex items-center gap-3 w-full px-4 py-2.5 text-sm text-red-500 rounded-xl transition-all ${isDarkMode ? 'hover:bg-red-500/10' : 'hover:bg-red-50'}`}>
                <RiLogoutBoxLine size={18} /> {t("sign_out_1")}
              </button>
            </div>
          }
        </div>
      </div>

      {profileDropdownOpen &&
      <div className="fixed inset-0 z-40" onClick={() => setProfileDropdownOpen(false)} />
      }
    </header>);

};

export default VendorHeader;